/**
 * The markets that are actually synced to the Klaviyo catalog. Any other
 * (European) market falls back to "de", which represents the shared EU catalog.
 * e.g. a visitor in Luxembourg resolves to the "de" catalog entry.
 */
const SYNCED_CATALOG_MARKETS = new Set(["no", "gb", "de"]);
const FALLBACK_CATALOG_MARKET = "de";

/**
 * Maps a storefront country to a market that exists in the Klaviyo catalog.
 * Norway and the UK have their own entries; everything else uses the DE/EU one.
 */
function toCatalogMarket(country: string): string {
  const cc = country.toLowerCase();
  return SYNCED_CATALOG_MARKETS.has(cc) ? cc : FALLBACK_CATALOG_MARKET;
}

/**
 * Constructs a Google Merchant feed compatible product ID. This is the Centra Database ID.
 * Format: 1/{market}-p{centraProduct}-v{centraVariant}-s{itemNumber}
 *
 * The {market} segment is resolved to a market that exists in the Klaviyo
 * catalog (see {@link toCatalogMarket}), since the catalog is only synced for
 * a subset of the countries the storefront serves.
 */
export function buildMerchantFeedId(
  centraProduct: string | undefined,
  centraVariant: string | undefined,
  country: string | undefined,
  item: string | undefined,
): string | null {
  if (!centraProduct || !centraVariant || !country || !item) return null;
  const itemNumber = item.split("-")[1];
  if (!itemNumber) return null;
  const market = toCatalogMarket(country);
  return `1/${market}-p${centraProduct}-v${centraVariant}-s${itemNumber}`;
}
